"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var HeaderLayout_1 = __importDefault(require("./HeaderLayout"));
var core_1 = require("@material-ui/core");
var KeyboardArrowUp_1 = __importDefault(require("@material-ui/icons/KeyboardArrowUp"));
var logo_png_1 = __importDefault(require("../assets/images/logo.png"));
var FooterLayout_1 = __importDefault(require("./FooterLayout"));
var BannerLayout_1 = __importDefault(require("./BannerLayout"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        scroll: {
            position: 'fixed',
            bottom: theme.spacing(2),
            right: theme.spacing(2),
        },
        footer: {
            left: 'auto',
            right: '0px'
        },
        logo: {
            flexGrow: 1,
        }
    });
});
function ScrollTop(props) {
    var children = props.children, window = props.window;
    var classes = useStyles();
    var trigger = core_1.useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    });
    var handleClick = function (event) {
        var anchor = (event.target.ownerDocument || document).querySelector('#top');
        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    return (react_1.default.createElement(core_1.Zoom, { in: trigger },
        react_1.default.createElement("div", { onClick: handleClick, role: "presentation", className: classes.scroll }, children)));
}
var DefaultLayout = function (props) {
    var classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.AppBar, null,
            react_1.default.createElement(core_1.Toolbar, null,
                react_1.default.createElement("span", { className: classes.logo },
                    react_1.default.createElement("img", { src: logo_png_1.default }),
                    " "),
                react_1.default.createElement(HeaderLayout_1.default, null))),
        react_1.default.createElement(core_1.Toolbar, { id: "top" }),
        react_1.default.createElement(BannerLayout_1.default, null),
        props.children,
        react_1.default.createElement(FooterLayout_1.default, null),
        react_1.default.createElement(ScrollTop, __assign({}, props),
            react_1.default.createElement(core_1.Fab, { color: "secondary", size: "small", "aria-label": "scroll back to top" },
                react_1.default.createElement(KeyboardArrowUp_1.default, null)))));
};
exports.default = DefaultLayout;
